import { useQuery } from "@tanstack/react-query";
import { useTRPC } from "../../../shared/api/trpc";

// Какие способы входа открыты на этом сервере: код из письма и/или провайдер OIDC.
export function useLoginMethods() {
  const trpc = useTRPC();
  return useQuery(trpc.auth.methods.queryOptions());
}
